import { ReactElement } from 'react';

import { ChakraTabPanel, ChakraTabPanels } from '@equip.health/ui';

import { CalendarTab } from '~/lib/util/calendar.util';

import Availability from './Availability';
import GroupClass from './GroupClass';
import Integration from './Integration';
import Schedule from './Schedule';
import GroupsV2 from '../groupsV2/GroupsWrapper';

const CalendarTabsMap: Record<CalendarTab, ReactElement> = {
  [CalendarTab.AVAILABILITY]: <Availability />,
  [CalendarTab.GROUP_CLASS]: <GroupClass />, // this will be removed when the new group design is implemented, at which point the GROUP_CLASS tab will render GroupsWrapper instead
  [CalendarTab.GROUP]: <GroupsV2 />,
  [CalendarTab.INTEGRATION]: <Integration />,
  [CalendarTab.SCHEDULE]: <Schedule />,
};

const TOP_LEVEL_ID = 'calendar__tabs__panels';

const CalendarPanels = () => {
  return (
    <ChakraTabPanels height="100%" id={TOP_LEVEL_ID} overflow="hidden">
      {Object.entries(CalendarTabsMap).map(
        ([tab, TabComponent]: [string, ReactElement]) => (
          <ChakraTabPanel
            height="100%"
            id={`${TOP_LEVEL_ID}-${tab}`}
            key={tab}
            padding={0}
          >
            {TabComponent}
          </ChakraTabPanel>
        ),
      )}
    </ChakraTabPanels>
  );
};

export default CalendarPanels;
